import { Col, Modal, Row, Tabs } from 'antd'
import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams, useNavigate, useSearchParams } from 'react-router-dom'
import JobCandidateList from './Components/JobCandidateList'
import InstituteInfo from './Components/InstituteInfo'
import PreviewHeader from './PageHeader'
import {
  ActionButton,
  ContainerWrapper,
  PageWrapper,
  TextWithIcon,
  JobPreviewTabs,
} from './style'

import CloseRoleDrawer from '../../components/UIComponents/CloseRolePopup'
import PreviewPage from '../../components/UIComponents/PreviewScreen'
import ShortlistIcon from '../../components/icons/Shortlist'
import { debounce } from '../../utils/debounce'
import RoleStatus from './RoleStatus'
import RoleCancelledTemplate from 'components/EmailTemplate/RoleCancelledTemplate'
import ReactDOMServer from 'react-dom/server'
import { sendNotificationBulkEmail, sendInAppNotification, sendNotificationBulkEmailWhatsapp } from 'modules/Students/actions'
import { getAppliedCollegesList, setSingleRoleData, closeApplication } from 'modules/Roles/actions'
import rolesSelectors from 'modules/Roles/selectors'
import authSelector from 'modules/Auth/selectors'
import ApprovedModelIcon from '../../components/icons/ApprovedModelIcon'
export default function JobPreviewIndex({
  getPreviewData,
  previewData,
  getJobRolePreview,
  getJobRoleCandidateList,
  getCandidateMetrics,
  CloseRole,
  getPlacementHistoryList,
  getExportFiledData,
  exportCandidate,
  instituteCampusId,
  getStudentPlacedList,
  getPreview,
  getOneRoleExports,
  duplicateRole,
  completeRole,
  getJobRoleCandidateAppliedList,
  getRoleData,
  singleRoleData,
  getAppliedCollegesList
}) {
  const params = useParams()
  let [searchParams, setSearchParams] = useSearchParams()
  const queryFilter = searchParams.get('q')
  const categorayFilter = searchParams.get('selectedCategory')
  const tabParam = searchParams.get('tab')
  const roleId = params.roleId
  const [isLoading, setIsLoading] = useState(false)
  const [isDuplicateLoading, setIsDuplicateLoading] = useState(false)
  const [data, setData] = useState({})
  const [activeTab, setActiveTab] = useState(tabParam || '1')
  const [collegesLoading, setCollegesLoading] = useState(false)
  const [showEntendRolePopup, setShowEntendRolePopup] = useState(false)
  const handleEditRole = () => {
    setShowEntendRolePopup(true)
  }
  const handleCloseClick = () => {
    setShowEntendRolePopup(false)
  }
  const handleApproveClick = () => {
    setShowEntendRolePopup(false)
    navigate(`/roles/edit-role/${roleId}`)
  }
  const navigate = useNavigate()
  const jobRolePreviewData = useSelector(
    state => state?.jobRolesPreview?.getJobRoleData
  )
  const jobRoleCandidateList = useSelector(
    state => state?.jobRolesPreview?.getCandidateListData
  )

  const instituteDetails = useSelector(
    state => state?.auth?.instituteDetails
  )
  const accessLevel = instituteDetails?.instituteSubscription?.accessLevel



  const metricsData = useSelector(state => state?.jobRolesPreview?.metricsData)
  const appliedCollegesList = useSelector(rolesSelectors.getAppliedCollegesList)

  const objectRef = useRef()
  const [state, setState] = useState({
    candidateListPageNo: 0,
    candidateListPageLimit: 10,
    candidateStatus: 'ELIGIBLE',
    selectedIndex: 1,
    candidateSearch: '',
    candidateListLoading: false,
  })

  const dispatch = useDispatch()

  // Redux selectors for institute and user information
  const institute = useSelector(state => state.auth.instituteDetails)
  const userData = useSelector(state => state.auth.userData)
  const userRole = useSelector(state => state.auth.userRole)

  // Function to get the user role name
  const getRoleName = id => {
    let roleName = userRole?.filter(data => data?.id === id)[0]?.name
    return roleName ?? 'Admin'
  }

  // Get the user role name
  const getUserRoleName = () => {
    return getRoleName(
      userData?.pluginlive_id
        ? userData?.admin?.instRoleId
        : userData?.admin_role_id ?? userData?.role_id
    )
  }

  const getHeaderIndex = status => {
    let response = {}
    switch (status) {
      case 'ELIGIBLE':
        response = {
          candidateStatus: 'ELIGIBLE',
          selectedIndex: 1,
        }
        setState(prevState => ({
          ...prevState,
          ...response,
        }))
        return response
      case 'RESTRICTED':
        response = {
          candidateStatus: 'RESTRICTED',
          selectedIndex: 6,
        }
        setState(prevState => ({
          ...prevState,
          ...response,
        }))
        return response

      case 'INELIGIBLE':
        response = {
          candidateStatus: 'INELIGIBLE',
          selectedIndex: 2,
        }
        setState(prevState => ({
          ...prevState,
          ...response,
          candidateStatus: 'INELIGIBLE',
          selectedIndex: 2,
        }))
        return response

      case 'APPLIED':
        response = {
          candidateStatus: 'APPLIED',
          selectedIndex: 3,
        }
        setState(prevState => ({
          ...prevState,
          ...response,
          candidateStatus: 'APPLIED',
          selectedIndex: 3,
        }))
        return response
      case 'MISSED':
        response = {
          candidateStatus: 'MISSED',
          selectedIndex: 4,
        }
        setState(prevState => ({
          ...prevState,
          ...response,
          candidateStatus: 'MISSED',
          selectedIndex: 4,
        }))
        return response
      case 'PLACED':
        response = {
          candidateStatus: 'PLACED',
          selectedIndex: 5,
        }
        setState(prevState => ({
          ...prevState,
          ...response,
          candidateStatus: 'PLACED',
          selectedIndex: 5,
        }))
        return response
      case 'MOVED_EVALUATION_PROCESS':
        response = {
          candidateStatus: 'MOVED_EVALUATION_PROCESS',
          selectedIndex: 4,
        }
        setState(prevState => ({
          ...prevState,
          ...response,
        }))
        return response
      case 'INTENT_TO_OFFER':
        response = {
          candidateStatus: 'INTENT_TO_OFFER',
          selectedIndex: 6,
        }
        setState(prevState => ({
          ...prevState,
          ...response,
        }))
        return response
      case 'JOINED':
        response = {
          candidateStatus: 'JOINED',
          selectedIndex: 5,
        }
        setState(prevState => ({
          ...prevState,
          ...response,
        }))
        return response
      default:
        break
    }
  }

  // useEffect(() => {
  //   const fetchStudentFilterList = async () => {
  //     try {
  //       const response = await getJobRoleCandidateAppliedList(params?.roleId)
  //       setStudentList(response?.data?.data?.candidateData?.result)
  //     } catch (error) {
  //       console.error('Error fetching applied candidate list:', error)
  //     }
  //   }

  //   fetchStudentFilterList() // Call the async function
  // }, [])

  const onPageChange = page => {
    let pageNo = page - 1
    objectRef.current.scrollIntoView({ behavior: 'smooth' })
    setState(prev => ({
      ...prev,
      candidateListPageNo: pageNo,
      candidateListLoading: true,
    }))
    getJobRoleCandidateList(
      roleId,
      pageNo,
      state.candidateListPageLimit,
      state.candidateStatus,
      state.candidateSearch,
      setIsLoading
    )
    clearLoadingState()
  }

  const clearLoadingState = () => {
    setTimeout(() => {
      setState(prev => ({
        ...prev,
        candidateListLoading: false,
      }))
    }, 500)
  }

  const corpId = useSelector(authSelector.getCorporateId)

  const fetchPreviewData = async id => {
    try {
      const response = await getJobRolePreview(id)
      setData(response?.data?.data)
    } catch (error) {
      console.error('Error fetching preview data:', error)
      throw error // Rethrow the error to be caught by the caller
    }
  }

  const fetchAppliedColleges = async () => {
    try {
      setCollegesLoading(true)
      const response = await getAppliedCollegesList({
        roleId: roleId,
        pageLimit: 10,
        pageNum: 0,
        setLoading: setCollegesLoading
      })
      // The action already handles dispatching to Redux, so we don't need to do it here
    } catch (error) {
      console.error('Error fetching applied colleges:', error)
    } finally {
      setCollegesLoading(false)
    }
  }

  useEffect(() => {
    // Only apply query filter for candidate list tab (tab 1), not for Institute Info tab
    const query = activeTab === '1' ? getHeaderIndex(queryFilter?.toUpperCase() ?? '') : null
    const fetchData = async () => {
      try {
        setIsLoading(true)
        await fetchPreviewData(roleId)
        await getJobRoleCandidateList(
          roleId,
          state.candidateListPageNo,
          state.candidateListPageLimit,
          query ? query?.candidateStatus : state.candidateStatus,
          state.candidateSearch,
          setIsLoading
        )
        await getCandidateMetrics(roleId)
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoading(false)
      }
    }
    fetchData()
  }, [])

  useEffect(() => {
    if (activeTab === '2') {
      fetchAppliedColleges()
    }
  }, [activeTab])

  // Update active tab when URL tab parameter changes
  useEffect(() => {
    const tabParam = searchParams.get('tab')
    if (tabParam) {
      setActiveTab(tabParam)
    }
  }, [searchParams.toString()])

  const handleHeaderCellClick = (index, data) => {
    setState({
      ...state,
      selectedIndex: index,
      candidateStatus: data,
      candidateListPageNo: 0,
      candidateListLoading: true,
    })
    searchParams.set('q', data)
    navigate({
      pathname: location.pathname,
      search: searchParams?.toString(),
    })
    getJobRoleCandidateList(
      roleId,
      0,
      state.candidateListPageLimit,
      data,
      state.candidateSearch,
      setIsLoading
    )
    clearLoadingState()
  }

  const handleSearch = data => {
    setState(prev => ({
      ...prev,
      candidateSearch: data,
      candidateListLoading: true,
    }))
    fetchCandidateList(data)
  }

  const fetchCandidateList = useCallback(
    debounce(searchTerm => {
      getJobRoleCandidateList(
        roleId,
        0,
        state.candidateListPageLimit,
        state.candidateStatus,
        searchTerm,
        setIsLoading
      )
      clearLoadingState()
    }, 1000),
    [
      roleId,
      state.candidateListPageNo,
      state.candidateListPageLimit,
      state.candidateStatus,
    ]
  )

  const onHandleClose = async () => {
    try {
      // Check if role should be reopened or closed
      const shouldReopen = jobRolePreviewData?.roleStatus === 'ROLE_CLOSED'
        || jobRolePreviewData?.roleStatus === 'COMPLETED'

      if (shouldReopen) {
        // For reopening, use the existing CloseRole method since closeApplication only closes
        const payload = {
          status: 'RE_OPEN',
          isCompanyId: false,
        }
        // CloseRole arrives via connect's mapDispatchToProps, so it is already
        // bound — calling it dispatches the thunk and returns its promise.
        // Wrapping it in dispatch() again dispatched that *promise*, which redux
        // rejects ("Actions must be plain objects"), and only after the POST had
        // gone out. The throw skipped the refetch below and the catch swallowed
        // it, so the role reopened on the server while the screen kept showing
        // it closed. Do not re-wrap a connected action.
        await CloseRole(corpId, roleId, payload)
        await fetchPreviewData(roleId)
      } else {
        // For closing, use the closeApplication action
        await dispatch(closeApplication(roleId))
        await fetchPreviewData(roleId)
      }

      // Get student list for notifications (only if closing)
      const response = await getJobRoleCandidateAppliedList(params?.roleId)
      let studentList = response?.data?.data?.candidateData?.result

      // If we have students who applied for this role, send them notifications
      if (studentList && studentList.length > 0 && !shouldReopen) {
        // Collect data for email notifications
        const emailPayloads = studentList.map(student => {
          const emailData = {
            companyName: jobRolePreviewData?.company?.companyName,
            jobTitle: jobRolePreviewData?.tittle,
            studentName: `${student.firstName} ${student.lastName}`,
            signatureName: userData?.first_name + ' ' + userData?.last_name,
            signatureRole: getUserRoleName(),
            signatureInstitute: institute?.campusName || 'Institute',
            signatureContact: userData?.phone_number || institute?.contactNumber
          }

          const emailTemplate = ReactDOMServer.renderToString(
            <RoleCancelledTemplate data={emailData} />
          )

          return {
            to: student.primaryEmail,
            subject: `Role Cancelled - ${jobRolePreviewData?.tittle} at ${jobRolePreviewData?.company?.companyName}`,
            htmlBody: emailTemplate
          }
        })

        // Send email notifications
        if (emailPayloads.length > 0) {
          await dispatch(sendNotificationBulkEmail(emailPayloads))
        }

        // Collect all student IDs for in-app notifications
        const studentIds = studentList.map(student => student.id)

        // Create in-app notification for all students
        if (studentIds.length > 0) {
          const inAppObj = {
            notification: {
              students: [{
                ids: studentIds,
                userIds: [],
                roles: ["Student"],
                issuer: "institute",
                createFor: "student",
                inApp: true,
                body: `Job role cancelled: ${jobRolePreviewData?.tittle} at ${jobRolePreviewData?.company?.companyName}`,
                tag: "Role",
                actions: [{
                  name: "View",
                  deep_link: `roles/viewrole/${jobRolePreviewData?.company?.id}/${jobRolePreviewData?.id}`,
                  route: `roles/viewrole/${jobRolePreviewData?.company?.id}/${jobRolePreviewData?.id}`,
                  parameters: {}
                }]
              }]
            }
          }

          await dispatch(sendInAppNotification(inAppObj))
        }

        // Prepare WhatsApp notifications
        const whatsappPayloads = studentList.map(student => {
          // Extract just the last 10 digits of the phone number
          const phoneNumber = student.phoneNumber.replace(/\D/g, '').slice(-10)

          return {
            to: phoneNumber,
            templateName: 'tpo_application_close',
            type: 'template',
            components: [
              {
                type: 'BODY',
                parameters: [
                  { type: 'TEXT', text: `${student.firstName} ${student.lastName}` }, // {{1}} - Student name
                  { type: 'TEXT', text: jobRolePreviewData?.company?.companyName },  // {{2}} - Company name
                  { type: 'TEXT', text: jobRolePreviewData?.tittle }                 // {{3}} - Role name
                ]
              }
            ]
          }
        })

        // Send WhatsApp notifications
        if (whatsappPayloads.length > 0) {
          await dispatch(sendNotificationBulkEmailWhatsapp(whatsappPayloads))
        }
      }
    } catch (err) {
      console.error('Error while closing role:', err)
    }
  }

  const handleBack = () => {
    navigate(`/rolePage`)
  }

  const handleNavigate = () => {
    const driveId = jobRolePreviewData?.driveRoleMap?.[0]?.id;
    if (driveId) {
      navigate(`/drives/${driveId}/role/${roleId}`)
    } else {
      console.error('Drive ID not found in driveRoleMap');
      // Fallback navigation or error handling
      navigate(`/rolePage`);
    }
  }

  const onHandleComplete = async () => {
    await completeRole(roleId)
    await fetchPreviewData(roleId)
  }

  const onActionsClick = (jobId, action) => {
    if (action == 'duplicate') {
      confirm({
        title: 'Duplicate Role?',
        okText: 'Confirm',
        okType: 'primary',
        cancelText: 'Cancel',
        onOk: async () => {
          try {
            const response = await duplicateRole(jobId)
            if (response?.status >= 200 && response?.status < 300) {
              navigate(`/rolePage`);
              getRoleData()
            }
            return true;
          } catch (error) {
            console.error('Error duplicating role:', error);
            return false;
          }
        },
      })
    }
  }

  const handleTabChange = (key) => {
    setActiveTab(key)

    // When Candidate Info tab (1) is clicked, redirect with specific query parameters
    if (key === '1') {
      searchParams.set('selectedCategory', 'PLACEMENT')
      searchParams.set('q', 'APPLIED')
      searchParams.set('tab', key)
      navigate({
        pathname: location.pathname,
        search: searchParams?.toString(),
      })

      // Update state to reflect the new query parameters
      const query = getHeaderIndex('APPLIED')
      if (query) {
        setState(prevState => ({
          ...prevState,
          ...query,
          candidateListPageNo: 0,
          candidateListLoading: true,
        }))

        // Fetch candidate list with new parameters
        getJobRoleCandidateList(
          roleId,
          0,
          state.candidateListPageLimit,
          query.candidateStatus,
          state.candidateSearch,
          setIsLoading
        )
        clearLoadingState()
      }
    } else {
      // For other tab changes, just update the URL tab parameter
      searchParams.set('tab', key)
      navigate({
        pathname: location.pathname,
        search: searchParams?.toString(),
      })
    }
  }

  const onEditClick = async (jobId, roleStatus, roleData) => {
    await dispatch(setSingleRoleData(roleData))
    if (roleData?.republishedDate) {
      handleEditRole()
    } else {
      navigate(`/roles/edit-role/${jobId}?CS=${roleData?.currentState}`)
    }
  }

  return (
    <ContainerWrapper>
      <PreviewHeader
        previewData={jobRolePreviewData}
        getExportFiledData={getExportFiledData}
        exportCandidate={exportCandidate}
        instituteCampusId={instituteCampusId}
        handleBack={handleBack}
        handleNavigate={handleNavigate}
        status={state.candidateStatus}
        isLoading={isLoading}
        setSearchParams={setSearchParams}
        categorayFilter={categorayFilter}
        downlaodData={state?.selectedIndex}
        getOneRoleExports={getOneRoleExports}
        onHandleClose={onHandleClose}
        completeRole={completeRole}
        onHandleComplete={onHandleComplete}
      />
      <PageWrapper>
        <Row>
          <Col md={12} xs={12}>
            <PreviewPage
              jobId={roleId}
              previewData={jobRolePreviewData}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              duplicateRole={duplicateRole}
              forPreviewPage={true}
              accessLevel={accessLevel}
              onActionsClick={onActionsClick}
              onEditClick={onEditClick}
              getRoleData={getRoleData}
            />
          </Col>
          <Col md={12} xs={12}>
            <Row style={{ marginBottom: 20 }}>
              <Col md={24} xs={24}>
                <TextWithIcon justify={'end'}>
                  <RoleStatus
                    jobRolePreviewData={jobRolePreviewData}
                    isLoading={isLoading}
                  />
                </TextWithIcon>
              </Col>
            </Row>
            <JobPreviewTabs
              activeKey={activeTab}
              onChange={handleTabChange}
              className={activeTab === '1' ? 'tab-left' : 'tab-right'}
            >
              <Tabs.TabPane tab="Candidate Info" key="1">
                <JobCandidateList
                  getPreview={getPreview}
                  candidateList={jobRoleCandidateList?.candidateData || {}}
                  onPageChange={onPageChange}
                  state={state}
                  setState={setState}
                  objectRef={objectRef}
                  metricsData={metricsData}
                  handleHeaderCellClick={handleHeaderCellClick}
                  handleSearch={handleSearch}
                  getPlacementHistoryList={getPlacementHistoryList}
                  getStudentPlacedList={getStudentPlacedList}
                  jobRolePreviewData={jobRolePreviewData}
                  getJobRolePreview={getJobRolePreview}
                  isLoadingState={isLoading}
                  queryFilter={queryFilter}
                  categorayFilter={categorayFilter}
                  exportCandidate={exportCandidate}
                  getExportFiledData={getExportFiledData}
                  params={params}
                  instituteCampusId={instituteCampusId}
                  status={state.candidateStatus}
                  downlaodData={state?.selectedIndex}
                  instituteDetails={instituteDetails}
                />
              </Tabs.TabPane>
              <Tabs.TabPane tab="Institute Info" key="2">
                <InstituteInfo
                  getPreview={getPreview}
                  candidateList={appliedCollegesList || {}}
                  onPageChange={onPageChange}
                  state={state}
                  setState={setState}
                  objectRef={objectRef}
                  metricsData={metricsData}
                  handleHeaderCellClick={handleHeaderCellClick}
                  handleSearch={handleSearch}
                  getPlacementHistoryList={getPlacementHistoryList}
                  getStudentPlacedList={getStudentPlacedList}
                  jobRolePreviewData={jobRolePreviewData}
                  getJobRolePreview={getJobRolePreview}
                  isLoadingState={collegesLoading}
                  categorayFilter={categorayFilter}
                  exportCandidate={exportCandidate}
                  getExportFiledData={getExportFiledData}
                  params={params}
                  instituteCampusId={instituteCampusId}
                  status={state.candidateStatus}
                  downlaodData={state?.selectedIndex}
                  instituteDetails={instituteDetails}
                />
              </Tabs.TabPane>
            </JobPreviewTabs>
          </Col>
        </Row>
        {showEntendRolePopup && (
          <CloseRoleDrawer
            description={
              <>
                This application has already been edited once. You can now
                only modify the end date and time.
              </>
            }
            Textdescription={'All other fields will remain locked.'}
            Icon={ApprovedModelIcon}
            showDrawer={showEntendRolePopup}
            setShowDrawer={setShowEntendRolePopup}
            onCloseClick={handleCloseClick}
            onApprove={handleApproveClick}
            closeText={'Back'}
            YesText={'Edit'}
            closeButtonHeight={'38px'}
            closeButtonWidth={'80px'}
            yesButtonHeight={'38px'}
            yesButtonWidth={'105px'}
          />
        )}
      </PageWrapper>
    </ContainerWrapper>
  )
}
